var map = {
	"./AIBee.jpg": 130,
	"./Fraz_portfolio_hero_high_quality.png": 55,
	"./ITU.png": 131,
	"./address_image.svg": 132,
	"./animated_fraz.png": 133,
	"./animated_logo.svg": 134,
	"./ar_vr_business.png": 135,
	"./blogs_image.svg": 136,
	"./cloud_infrastructure.svg": 137,
	"./codeInLogo.png": 138,
	"./contactMail.png": 139,
	"./coursera_logo.png": 140,
	"./data_science.svg": 141,
	"./deeplearning_ai_logo.png": 142,
	"./delhivery_logo.png": 143,
	"./developerActivity.svg": 144,
	"./dsc_logo.png": 145,
	"./education.svg": 146,
	"./experience.svg": 147,
	"./feelingProud.svg": 148,
	"./fraz_profile.png": 149,
	"./freecopy_logo.png": 150,
	"./fullstack.svg": 151,
	"./funzoft.jpg": 152,
	"./gcp_logo.png": 153,
	"./generative_ai.png": 154,
	"./github_logo.png": 155,
	"./googleAssistant.jpg": 156,
	"./googleAssistant.svg": 157,
	"./google_ads.png": 158,
	"./google_logo.png": 159,
	"./ibm_logo.png": 160,
	"./iiitk_logo.png": 161,
	"./intel_logo.jpg": 162,
	"./iu_logo.png": 163,
	"./jsFramework.svg": 164,
	"./legato_logo.png": 165,
	"./madecraft_logo.png": 166,
	"./manOnTable.svg": 167,
	"./microsoft_logo.png": 168,
	"./mozilla_logo.png": 169,
	"./muffito_logo.png": 170,
	"./nextuLogo.jpg": 171,
	"./nptel_logo.png": 172,
	"./orzeh_technologies.jpg": 173,
	"./pgc.png": 174,
	"./portfolio.gif": 175,
	"./programmer.svg": 176,
	"./projects_image.svg": 177,
	"./prompt_engineering.png": 178,
	"./pwa.png": 179,
	"./saayaHealthLogo.png": 180,
	"./stanford_logo.png": 181,
	"./talksCardBack.svg": 182,
	"./talksCardBackAlt.svg": 183,
	"./tiktok_logo.png": 184,
	"./ui_ux_design.svg": 185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;